import React from "react";
import { arrayOf, bool, node, object, oneOfType, string } from "prop-types";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CollectionBanner from "../../atoms/CollectionBanner";

const ComponentContainer = ({
  collection = {},
  children,
  className = "",
  isTitle = true,
  isBanner = false,
  childContainer = false,
  titleClass = "",
  bannerClass = "",
  arrowColor = "",
  ...props
}) => {
  const { hide_bottom_space: hideBottomSpace, show_collection_name_website: showCollectionName } =
    collection["associated-metadata"] || {};

  const top = showCollectionName ? (
    <CollectionTitleWithArrow className={titleClass} collection={collection} arrowColor={arrowColor} {...props} />
  ) : isBanner ? (
    <CollectionBanner className={bannerClass} collection={collection} {...props} />
  ) : null;

  return (
    <div {...props} className={`${className} ${childContainer || hideBottomSpace ? "" : "bottom-space"}`}>
      {isTitle && top}
      {children}
    </div>
  );
};

ComponentContainer.propTypes = {
  collection: object,
  children: oneOfType([arrayOf(node), node]).isRequired,
  className: string,
  isTitle: bool,
  isBanner: bool,
  childContainer: bool,
  titleClass: string,
  bannerClass: string,
  arrowColor: string,
};

export default ComponentContainer;
